import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { CalibrationInfo, CalibrationItem, Question } from 'types';
import CalibrationEntry from './CalibrationEntry';

interface CalibrationPopoverProps {
  calibrationInfo: CalibrationInfo;
  question: Question;
}

const CalibrationPopover: React.FC<CalibrationPopoverProps> = ({
  calibrationInfo,
  question,
}) => {
  return (
    <>
      {!!calibrationInfo && !!calibrationInfo.calibrationItems?.length && (
        <div className="mb-2">
          <span className="text-muted text-uppercase">
            <FormattedMessage
              id="app.views.widgets.dashboards.team_dashboard.calibration.calibration_popover.calibrations"
              defaultMessage="Calibrations"
            />
          </span>
        </div>
      )}
      {!!calibrationInfo &&
        !!calibrationInfo.calibrationItems?.length &&
        calibrationInfo.calibrationItems.map((item: CalibrationItem, idx) => (
          <div key={idx} className="mb-2">
            <CalibrationEntry question={question} calibrationItem={item} />
          </div>
        ))}
      {!!calibrationInfo && !!calibrationInfo.calibrationItems?.length && (
        <div className="mb-2">
          <hr className="mb-2 pb-0" />
          <span className="mt-0 pt-0 text-muted text-uppercase">
            <FormattedMessage
              id="app.views.widgets.dashboards.team_dashboard.calibration.calibration_popover.original_answer"
              defaultMessage="Original answer(s)"
            />
          </span>
        </div>
      )}
    </>
  );
};

export default CalibrationPopover;
